/**
 * Drops empty cells and rows before saving. A grid with nothing filled in becomes
 * null, so it counts as unanswered everywhere, including the required checks.
 *
 * Kept out of GridField.jsx so that file only exports its component.
 */
export const cleanGridValue = (value) => {
  if (!value || typeof value !== 'object') return null;

  const cleaned = {};

  Object.entries(value).forEach(([rowKey, row]) => {
    if (!row || typeof row !== 'object') return;

    const cells = {};
    Object.entries(row).forEach(([columnKey, cell]) => {
      const text = cell === null || cell === undefined ? '' : String(cell).trim();
      if (text) cells[columnKey] = text;
    });

    if (Object.keys(cells).length > 0) cleaned[rowKey] = cells;
  });

  return Object.keys(cleaned).length > 0 ? cleaned : null;
};
